const MS_PER_SECOND = 1_000;
const MS_PER_MINUTE = 60 * MS_PER_SECOND;
const MS_PER_HOUR = 60 * MS_PER_MINUTE;
const MS_PER_DAY = 24 * MS_PER_HOUR;
const MS_PER_MONTH = 30 * MS_PER_DAY;
const MS_PER_YEAR = 365 * MS_PER_DAY;
export const timeAgo = (target, base, intl, style = 'long', options = {}) => {
    const then = new Date(target).getTime();
    const now = new Date(base).getTime();
    if (!Number.isFinite(then) || !Number.isFinite(now)) {
        return '';
    }
    const diff = then - now;
    const absDiff = Math.abs(diff);
    const direction = diff > 0 ? 1 : -1;
    let unit = 'year';
    let unitMs = MS_PER_YEAR;
    if (absDiff < MS_PER_MINUTE) {
        unit = 'second';
        unitMs = MS_PER_SECOND;
    }
    else if (absDiff < MS_PER_HOUR) {
        unit = 'minute';
        unitMs = MS_PER_MINUTE;
    }
    else if (absDiff < MS_PER_DAY) {
        unit = 'hour';
        unitMs = MS_PER_HOUR;
    }
    else if (absDiff < MS_PER_MONTH) {
        unit = 'day';
        unitMs = MS_PER_DAY;
    }
    else if (absDiff < MS_PER_YEAR) {
        unit = 'month';
        unitMs = MS_PER_MONTH;
    }
    const value = Math.floor(absDiff / unitMs);
    if (options.includeSuffix === false) {
        return intl.formatNumber(value, {
            style: 'unit',
            unit,
            unitDisplay: style === 'narrow' ? 'narrow' : 'short',
        });
    }
    return intl.formatRelativeTime(value * direction, unit, {
        numeric: 'always',
        style,
    });
};
//# sourceMappingURL=time.js.map